const Checklist = require('./checklist')
const checklist_items_free = require('./checklist_items_free')
const checklist_items_pro = require('./checklist_items_pro')

function getChecklist(user) {
    const items = (
        user.hasFeature('upgrade')
            ? checklist_items_pro
            : checklist_items_free
    )
    return new Checklist({
        user,
        items,
    })
}

module.exports = getChecklist
